// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2s4T-","addWidgetButton":"Header_addWidgetButton__3scEF","dashboardTabs":"Header_dashboardTabs__2w_Z0","active":"Header_active__36pe0"};